module.exports = __webpack_public_path__ + "img/plus-icon.22c1f8d0.svg";